$( ->
  init_limit = (parent)->
    parent.find('.limited_height').each ->
      the_div = $(this)
      unless the_div.data('limit-original-height')?
        the_div.data('limit-original-height', the_div.height())
        if the_div.height() > the_div.data('height')
          the_div.css('height', the_div.data('height') + 'px')
          the_div.hoverIntent ->
            unless the_div.data('limit-open')?
              the_div.animate { height: the_div.data('limit-original-height') }, ->
                the_div.data('limit-open', true)
          , ->

  init_limit($(document))
  $('.dom_updatable').on 'dom_updated', ->
    init_limit($(this))

)
